import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/pages/home-page.vue'
import AppDetailPage from '@/pages/app-detail-page.vue'

Vue.use(VueRouter)

const routes = [
    { path: '/home', component: HomePage, name: 'HomePage' },
    { path: '/appdetail/:id', component: AppDetailPage, name: 'AppDetailPage', props: true },
    { path: '/', redirect: { name: 'HomePage' } },
    { path: '/**', redirect: { name: 'HomePage' } } 
]

const router = new VueRouter({
    routes
})

export default router